// Implements conversion from various currencies to Euro based on historical yearly rates.
// based on https://www.ecb.europa.eu/stats/policy_and_exchange_rates/euro_reference_exchange_rates/html/index.en.html
const rates = {
    "ΒΡΕΤΑΝΙΚΗ ΛΙΡΑ": {
        2024: 1.1812,
        2023: 1.1497,
        2022: 1.1727,
        2021: 1.1633,
        2020: 1.128631,
        2019: 1.139727,
        2018: 1.130081,
        2017: 1.141317,
        2016: 1.224833,
        2015: 1.377982,
        2014: 1.240494,
    },
    ΓΙΕΝ: {
        2024: 0.006103,
        2023: 0.006579,
        2022: 0.007245,
        2021: 0.007699,
        2020: 0.008256,
        2019: 0.008192,
        2018: 0.007674,
        2017: 0.007907,
        2016: 0.008329,
        2015: 0.007449,
        2014: 0.007125,
    },
    "ΔΟΛΑΡΙΟ ΑΥΣΤΡΑΛΙΑΣ": {
        2024: 0.6099,
        2023: 0.6139,
        2022: 0.6593,
        2021: 0.635,
        2020: 0.602138,
        2019: 0.620923,
        2018: 0.632851,
        2017: 0.679586,
        2016: 0.672243,
        2015: 0.677914,
        2014: 0.679508,
    },
    "ΔΟΛΑΡΙΟ ΗΠΑ": {
        2024: 0.9239,
        2023: 0.9248,
        2022: 0.9493,
        2021: 0.8455,
        2020: 0.887271,
        2019: 0.892882,
        2018: 0.847541,
        2017: 0.886758,
        2016: 0.904179,
        2015: 0.901699,
        2014: 0.753602,
    },
    "ΔΟΛΑΡΙΟ ΚΑΝΑΔΑ": {
        2024: 0.6749,
        2023: 0.6852,
        2022: 0.7312,
        2021: 0.674,
        2020: 0.656624,
        2019: 0.672823,
        2018: 0.653602,
        2017: 0.683136,
        2016: 0.682498,
        2015: 0.705726,
        2014: 0.682264,
    },
    "ΕΛΒΕΤΙΚΟ ΦΡΑΓΚΟ": {
        2024: 1.0498,
        2023: 1.029,
        2022: 0.9953,
        2021: 0.925,
        2020: 0.935939,
        2019: 0.898591,
        2018: 0.866034,
        2017: 0.900563,
        2016: 0.917609,
        2015: 0.938127,
        2014: 0.823343,
    },
    "ΡΟΥΒΛΙ ΡΩΣΙΑΣ": {
        2024: 0.01,
        2023: 0.01,
        2022: 0.011313,
        2021: 0.011474,
        2020: 0.012,
        2019: 0.014,
        2018: 0.013,
        2017: 0.014,
        2016: 0.014,
        2015: 0.016,
        2014: 0.021,
    },
};

/**
 * Convert an amount from a given currency and year into Euros.
 * @param {number} price - The original amount.
 * @param {string} currency - The currency key (in Greek, matching the rates object).
 * @param {number|string} year - The year of the rate to use.
 * @returns {number} - Converted amount in Euros, or original price if no rate found.
 */
function currencyToEuro(price, currency, year) {
    const yearStr = String(year);
    if (rates[currency] && rates[currency][yearStr] != null) {
        return price * rates[currency][yearStr];
    }
    // Fallback: no conversion rate available
    return Number(price);
}

module.exports = { currencyToEuro };
